import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-scroll';
import { FaBriefcase, FaCode, FaEnvelope, FaGraduationCap, FaHome, FaUser, FaHeadSideVirus  } from 'react-icons/fa';


const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpenMenu = () => {
        setIsOpen(!isOpen);
    }

    const handleMenuClick = () =>{
        setIsOpen(false)
    }
    return (
        <div className={`navbar-menu menu-container ${isOpen ? 'menu-open' : ''}`}>
            <input type="checkbox" id="openmenu" className="hamburger-checkbox" checked={isOpen} onChange={handleOpenMenu}/>

            <div className="hamburger-icon">
                <label htmlFor="openmenu" id="hamburger-label">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </label>
            </div>
            <div className="menu-pane">
                <nav className="mt-5">
                    <ul className="menu-links">
                        <li><Link onClick={handleMenuClick} to='home'><FaHome/> Home</Link></li>
                        <li><Link onClick={handleMenuClick} to='about'><FaUser/> About</Link></li>
                        <li><Link onClick={handleMenuClick} to='services'><FaBriefcase/> Services</Link></li>
                        <li><Link onClick={handleMenuClick} to='projects'><FaCode/> Projects</Link></li>
                        <li><Link onClick={handleMenuClick} to='testimonials'><FaGraduationCap/> Testimonials</Link></li>
                        <li><Link onClick={handleMenuClick} to='contact'><FaEnvelope/> Contact</Link></li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Navbar;